import React, { FC } from 'react'

import { BarProps } from '@Components/CMS/Bar/BarFactory/types'
import { RTEContent } from '@Components/RTEContent'
import GenericBar from '@Domains/Header/Features/Bars/Generic'
import { useRTEField } from '@Globals/CMS/FieldHelpers'

export const DefaultBar: FC<BarProps> = ({ bar, className, id, order, placement }) => {
  const text = useRTEField(bar.fields || [], 'text')
  const textLeft = useRTEField(bar.fields || [], 'textLeft')
  const mobileRTEField = useRTEField(bar.fields || [], 'textMobile')
  const textRight = useRTEField(bar.fields || [], 'textRight')

  return (
    <GenericBar
      key={bar.id}
      backgroundColor={bar.backgroundColor}
      className={className}
      contentLeft={textLeft && <RTEContent html={textLeft} />}
      contentMiddle={text && <RTEContent html={text} />}
      contentMobile={mobileRTEField && <RTEContent html={mobileRTEField} />}
      contentRight={textRight && <RTEContent html={textRight} />}
      id={id}
      order={order}
      placement={placement}
      textColor={bar.textColor}
    />
  )
}

export default DefaultBar
